import React from 'react';

const ColorSchemesPage = () => {
    return (
        <div>
            
        </div>
    );
}

export default ColorSchemesPage;
